import withSelectRateOfCountryToSend from 'components/Dashboard/HOCs/withSelectRateOfCountryToSend';
import ButtonCommon from 'components/common/ButtonCommon';
import useLang from 'hooks/useLang';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import ActiveItem from '../../../ExchangeRateItem/components/ActiveItem/ver2';
import ExchangeRateItemMobile from '../../../ExchangeRateItem/mobile/ver3';

const SelectRateOfCountryToSendButton =
  withSelectRateOfCountryToSend(ButtonCommon);

const ExchangeRateSectionMobile = ({ remittanceRatesData, countries }) => {
  const { t } = useLang();

  const [current, setCurrent] = useState(null);
  const [position, setPosition] = useState(0);

  const getCountryNameByCode = (countryCode) => {
    if (isEmpty(countries)) return null;
    const country = countries.find((country) => country.code === countryCode);
    return country ? country.name : '';
  };

  useEffect(() => {
    if (remittanceRatesData) {
      const countryCodes = Object.keys(remittanceRatesData);
      if (countryCodes.length > 0) {
        setCurrent(countryCodes[0]);
      }
    }
  }, [remittanceRatesData]);

  const handleOnSelect = (country, position) => {
    setCurrent(country);
    setPosition(position);
  };

  const remittanceRatesDataLength = Object.keys(
    remittanceRatesData || {}
  )?.length;
  const handleOnNext = () => {
    let pos = position;
    if (pos === remittanceRatesDataLength - 1) return;
    pos = pos + 1;
    setPosition(pos);
    setCurrent(Object.keys(remittanceRatesData)[pos]);
  };
  const handleOnPrev = () => {
    let pos = position;
    if (position === 0) return;
    pos = pos - 1;
    setPosition(pos);
    setCurrent(Object.keys(remittanceRatesData)[pos]);
  };

  if (!remittanceRatesData) {
    return null;
  }
  return (
    <Wrapper>
      <ActiveItem
        country={current}
        countryName={getCountryNameByCode(current)}
        rates={remittanceRatesData[current]}
        remittanceRatesDataLength={remittanceRatesDataLength}
        position={position}
        handleOnNext={handleOnNext}
        handleOnPrev={handleOnPrev}
      />
      <RatesWrap>
        <Rates>
          {Object.keys(remittanceRatesData).map((country, position) => (
            <ExchangeRateItemMobile
              key={country}
              country={country}
              rates={remittanceRatesData[country]}
              isActive={country === current}
              onClick={() => handleOnSelect(country, position)}
            />
          ))}
        </Rates>
      </RatesWrap>
      <SelectRateOfCountryToSendButton
        value={t('label_other_countries')}
        onClick={() => {}}
        styles={{
          margin: '0px',
          marginTop: '20px',
          marginInline: 'auto',
          paddingInline: '24px',
          width: 'fit-content',
          height: '30px',
          border: '1px solid #000',
          borderRadius: '100px',
          fontWeight: 500,
        }}
        background="var(--ds-c-white)"
        isFill={false}
        remittanceRatesData={remittanceRatesData}
        countries={countries}
      />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  height: fit-content;
  padding-bottom: 20px;

  font-family: var(--ff-primary);
  font-weight: 500;
  font-size: 12px;
  line-height: 26px;

  & b {
    color: var(--ds-c-red);
  }
`;

const RatesWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

const Rates = styled.div`
  display: flex;
  gap: 20px;
`;

export default ExchangeRateSectionMobile;
